import React from 'react';

import { LandingPage } from '@/components/LandingPage/LandingPage';

export default function Home() {
  return <LandingPage />;
}
